module.exports = __webpack_public_path__ + "img/966.3f101305.gif";